var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1895 0C7.54166 8.60483e-05 7.88257 0.124076 8.1525 0.35025L8.25 0.4395L11.5605 3.75C11.8095 3.99902 11.963 4.32771 11.994 4.6785L12 4.8105V12.5C12.0001 12.8784 11.8572 13.2429 11.5999 13.5204C11.3426 13.7979 10.9899 13.9679 10.6125 13.9963L10.5 14H1.5C1.12157 14.0001 0.757075 13.8572 0.479589 13.5999C0.202103 13.3426 0.0321326 12.9899 0.00375016 12.6125L7.5201e-08 12.5V1.5C-0.000119684 1.12157 0.142805 0.757075 0.400123 0.479589C0.657441 0.202103 1.01013 0.0321325 1.3875 0.00375009L1.5 0H7.1895ZM6 1.5H1.5V12.5H10.5V6H7.125C6.84534 5.99999 6.57571 5.89581 6.36869 5.70779C6.16166 5.51976 6.0321 5.26137 6.00525 4.983L6 4.875V1.5ZM7.5 1.8105V4.5H10.1895L7.5 1.8105Z",
    fill: "#3677D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a8e945b583b85a111d2e93c3976acfe6.svg";
export { ForwardRef as ReactComponent };